const { getElements } = window.BAO.Utils

let dropdownLoaded = false
let lastScroll = window.scrollY

class HeaderDropdown extends window.BAO.CustomElement() {
  connectedCallback() {
    super.setupListeners()
    this.initialise()
  }

  initialise() {
    if (dropdownLoaded) return

    window.BAO.sectionRenderer
      .fetch("header", "/?view=dropdown")
      .then((res) => {
        dropdownLoaded = true

        const newDOM = window.BAO.sectionRenderer.convertToDOM(res.header)
        const myself = newDOM.querySelector(this.localName)

        this.outerHTML = myself.outerHTML

        setupDropdownScrollHandler()
      })
      .catch(() => { })
  }
}

function setupDropdownScrollHandler() {
  let isThrottled = false
  let lastScroll = 0
  let isScrolling = false
  let scrollEndTimer = null

  window.addEventListener("scroll", () => {
    if (isThrottled) return
    isThrottled = true

    requestAnimationFrame(() => {
      const currentScroll = window.scrollY

      // Only run once per continuous scroll
      if (currentScroll > lastScroll && !isScrolling) {
        isScrolling = true // block further triggers

        const focusedItems = getElements(".hd-Navigation_Item:hover")

        if (focusedItems.length > 0) {
          focusedItems.forEach((item) => {
            item.blur()
          })

          document.body.classList.add("hd-Header_DisableDropdown")
        }
      }

      // Detect scroll end (reset isScrolling)
      clearTimeout(scrollEndTimer)
      scrollEndTimer = setTimeout(() => {
        isScrolling = false
        document.body.classList.remove("hd-Header_DisableDropdown")
      }, 300) // user stopped scrolling

      lastScroll = currentScroll
      isThrottled = false
    })
  })
}

if (!customElements.get("header-dropdown")) {
  customElements.define("header-dropdown", HeaderDropdown)
}
